export const AboutContent = [
  {
    title: "What I enjoy doing",
    content: [
      "A website or web application should be something your users enjoy looking at and interact with.",
      " I help businesses and individuals communicate their needs and bring them to life with web technologies.",
    ],
  },
  {
    title: "My story",
    content: [
      "As a former Business Analyst who specialized in interaction design and usability, I helped companies by building many clever and invaluable business solutions in VBA, Access and SQL.",
      "Moreover, I worked closely with talented programmers on agile projects and got blown away by the 'magic' and the creativity. And so, decided to leverage my interests of programming, creativity and problem solving...and bring it to the web.",
      "That incredible journey brought me to ReactJS and responsive designing.",
    ],
  },
  {
    title: "What's next",
    content: [
      "Although, I have to admit... having been in control of all the data in my VBA solutions, my goal is to eventually produce 'magic' again and program CRUD 'trips' to backend databases.",
    ],
  },
  {
    title: "...and one more thing",
    content: [
      "I am bilingual in English and French.",
      "Consequently, I opted to lend my language skills for most monolingual companies I've worked for, translating Product User Guides as well as Sales & Marketing material.",
      "This has lead to multiple translation projects as a freelancer since 2019, for clients in North America, Europe and Asia.",
    ],
  },
];
